import { useState } from 'react'
import { CommandValues } from './types'

export function useSessionContext(storageKey: string) {
  // Snapshot sessionStorage on mount and return optimistic updates
  // to avoid fetching sessionStorage on every change
  const [values, setValues] = useState<CommandValues>(
    JSON.parse(sessionStorage.getItem(storageKey) || '{}')
  )

  const onChange = (next: CommandValues = {}) => {
    if (Object.keys(next).length === 0) {
      sessionStorage.removeItem(storageKey)
      setValues(next)
    } else {
      const update = Object.entries({ ...values, ...next }).reduce(
        (clean, [key, value]) => {
          if (value !== null && value !== undefined) {
            clean[key] = value
          }
          return clean
        },
        {} as CommandValues
      )
      sessionStorage.setItem(storageKey, JSON.stringify(update))
      setValues(update)
    }
  }

  return { values, onChange }
}
